export default function SubTitle1({ text }: { text: string }) {
  return <span className=" font-medium text-lg text-[#1f1f1f]">{text}</span>;
}
